<template>
    <div>
         <!-- 轮播图 -->
         <div class="wrapper">
                  <swiper :options="swiperOption" class="swiper-container">
                  <swiper-slide class="swiper-item"  v-for="item of detailist.banner"  :key="item.id">
                    <div class="img_div">
                          <img class="swiper-img" :src="item.url" alt="图片集"  />
                    </div>
                  </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination" slot="pagination" ></div>

        </div>


        <!--          右侧信息栏-->
        <div class="word_case">
              <div class="case_r">
                <div class="f18">
                  {{detailist.name}}
                </div>
                <div class="case_con f14" v-if="detailist.intro">
                  <span> {{detailist.intro}}</span>
                </div>
                <div class="case_infor col_6 f14" v-if="detailist.scene">
                  <span>{{detailist.scene}}</span>
                </div>
                <div class="case_infor f14" v-if="detailist.site">
                  <div>
                    <p class="fl p1">网址</p>
                    <p class="fl col_6"><a class="col_6" :href="detailist.site" target="_Blank" rel="nofollow">{{detailist.site}}</a>
                    </p>
                  </div>
                </div>

                <div class="case_infor"  v-if="detailist.code_img">
                  <div class="code_img">
                    <img  :src="detailist.code_img" />
                  </div>
                </div>

                <div class="case_click">
                  <el-button type="danger" icon="el-icon-arrow-left" circle @click.native="caseup"
                            :disabled="!detailist.caseup"></el-button>
                  <el-button type="danger" icon="el-icon-arrow-right" circle @click.native="casedown"
                            :disabled="!detailist.casedown"></el-button>
                </div>
              </div>
        </div>
    </div>
  </template>
  
  <script>
    export default {
      data(){
            return{
                  // swipers:'true',
                  casemenu: '2',
                  detailist: {
                    id: "",//案例id
                    name: "",
                    intro: '',
                    scene: '',
                    site: '',
                    caseups: '',
                    casedowns: '',
                    upId: '',
                    downId: '',
                    banner: [
                   
                    ]
                  },
          

                  swiperOption: {
                  pagination: {
                          el: ".swiper-pagination",
                          clickable: true // 允许点击小圆点跳转
                          },
                  autoplay: {
                  delay: 2500,
                  stopOnLastSlide: false,
                  disableOnInteraction: false
                  }, //自动播放
                  speed: 800, //滑动速度
                  setWrapperSize: true,
                  observeParents: true,
                  paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
                  loop: true, //循环
                  observer: true,
                  autoplayDisableOnInteraction: true //用户操作swiper之后，是否禁止autoplay
                  },
            }
          },
          methods:{
                  async getcase(val) {
                      if(this.casemenu == '' || this.casemenu == undefined){
                        this.casemenu = 2;
                        // console.log(this.casemenu)
                      }
                      var dt = await this.$axios.post('/api/details', {
                        case: val,
                        casemenu:this.casemenu
                      })
                      dt.data = JSON.parse(dt.data)
                      // console.log(dt)
                      if (dt.status == 200) {
                        if (dt.data.code !== 0) {
                          this.$message({
                            type: 'info',
                            message: dt.data.msg
                          });
                          return;
                        }
                      } else {
                        alert(dt.statusText)
                        return;
                      }
                      this.detailist = dt.data.data
                      this.$router.push({
                        name: 'medetails', params: {
                          id: val+'.html'
                        }
                      })
                      // console.log(open)
                      // console.log(dt.data)
                      // console.log(this.detailist)
                      // if(dt.data.data.banner.length==0){
                      //   this.swipers=false
                      // }
                    },

                    caseup() {
                      this.getcase(this.detailist.upId)
                    },
                    casedown() {
                      this.getcase(this.detailist.downId)
                    },
         },
         created() {
               this.casemenu = this.$route.params.casemenu;
               this.detailist.id = this.$route.params.id.split('.')[0];
               this.getcase(this.detailist.id)
         },
         updated:function(){  
           window.scroll(0, 0);
          },
         watch: {
          $route(to, from) {
            this.getcase(this.$route.params.id.split('.')[0])
          }
        },
   
    }
  </script>
  
  <style lang="less" scoped>
    .wrapper {  
                height:300px;
                margin-bottom: 10px;
                border-radius: 5px;
                overflow: hidden;
                position: relative;

                .img_div{
                        display: flex;
                        width: 100%;
                        min-height: 200px;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                }

                .swiper-img{
                        width: 100%;
                        min-height: 300px;
                }

                .swiper-pagination{
                  bottom: 20px;
                  width: 100%;
                }
        }

    .word_case{
           padding: 20px;
           overflow: hidden;
           position: relative;
           display: block;
           min-height: 300px;
           background: #fff;
           box-shadow: 1px 1px 8px -1px #999;
           border-radius: 5px;
           position: relative;

         

          .case_r {
            right: 10px;
            z-index: 99;
            .case_con {
              color: #666;
              line-height: 30px;
              padding-bottom: 16px;
              padding-top: 12px;
              border-bottom: 1px dotted #d9d9d9;
              overflow: hidden;
              span{
                overflow: hidden;
              /*-webkit-line-clamp: 2;*/
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              }
            }

            .case_infor {
              line-height: 30px;
              padding: 14px 0;
              border-bottom: 1px dotted #d9d9d9;
              overflow: hidden;

              span{
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }

              .code_img{
                width: 100px;
                img{
                  width: 100%;
                }
              }

              div {
                overflow: hidden;

                .p1 {
                  padding-right: 10px;
                }
              }
            }

            .case_click {
              display: flex;
              justify-content: center;
              align-content: center;
              width: 100%;
              padding: 20px 0 0;

              .el-button--danger:focus, .el-button--danger:hover{
                  background: #f56c6c;
                  border-color: #f56c6c;
                  color: #fff;
                }
            
            .is-disabled {
              color: #FFF;
              background-color: #fab6b6;
              border-color: #fab6b6;
            }

            .is-disabled:hover {
              color: #FFF;
              background-color: #fab6b6;
              border-color: #fab6b6;
            }

              a {
                display: inline-block;
                float: left;
                width: 48px;
                height: 48px;
                margin: 0 15px;
              }

              .case_click2 {
                background-image: url(../../assets/images/for_l.png);
              }

              .case_click3 {
                background-image: url(../../assets/images/for_r.png);
              }

            }
          }
      
    }

  </style>
  


// WEBPACK FOOTER //
// src/components/move/details.vue